import { EyeOutlined } from "@ant-design/icons";
import Colors from "../../../themes/Colors";
import { MenuOutlined } from "@ant-design/icons";
import Tooltip from "../../../components/Common/Tooltip";
import Space from "../../../components/Common/Space";
import CustomActionMenu from "../../../components/CustomActionMenu/CustomActionMenu";
import StatusPill from "../../../components/Common/StatusPill";
import { MODALIDADES_PSS } from "../utils/HospitalizacionConstant";
import moment from "moment";

export const columnasValidacionesHojaQX = ({
  renderActionColumn,
  tipoReclamante,
}) => {
  return [
    {
      title: "Número de ingreso",
      dataIndex: "estatusCobertura.numeroIngreso",
      key: "numeroIngreso",
      width: "12%",
      render: (_, record) => record?.estatusCobertura?.numeroIngreso || "N/A",
    },
    {
      title: "Código y nombre del procedimiento",
      dataIndex: "cobertura.cobRecl",
      key: "cobertura",
      width: "30%",
      render: (_, record) => {
        const codigo = record?.cobertura?.cobRecl;
        const nombre = record?.cobertura?.descCobertura;

        if (!codigo && !nombre) {
          return "N/A";
        }

        if (nombre && codigo) {
          return `(${codigo}) ${nombre}`;
        }

        if (nombre && !codigo) {
          return nombre;
        }

        if (codigo && !nombre) {
          return codigo;
        }

        return "N/A";
      },
    },
    {
      title:
        tipoReclamante === MODALIDADES_PSS.PAQUETE
          ? "Nombre del médico"
          : tipoReclamante === MODALIDADES_PSS.HIBRIDO
            ? "Código y/o nombre del médico"
            : "Código y nombre del médico",
      dataIndex: "cobertura.codMedicoRecl",
      key: "medico",
      width: "25%",
      render: (_, record) => {
        const codigo = record?.cobertura?.codMedicoRecl;
        const nombre = record?.cobertura?.nombreMedicoRecl;
        const codigoValido = codigo && codigo !== "0" && codigo !== 0;
        const tieneNombre = !!nombre;
        const tieneCodigo = !!codigo;

        if (!tieneCodigo && !tieneNombre) {
          return "N/A";
        }

        if (tipoReclamante === MODALIDADES_PSS.PAQUETE) {
          return nombre || "N/A";
        }

        if (tipoReclamante === MODALIDADES_PSS.ARS || tipoReclamante === MODALIDADES_PSS.HIBRIDO) {
          if (tieneNombre && codigoValido) {
            return `(${codigo}) ${nombre}`;
          }

          if (tieneNombre) {
            return nombre;
          }

          if (codigoValido) {
            return codigo;
          }
        }

        return "N/A";
      },
    },
    {
      title: "Fecha de ingreso",
      dataIndex: "estatusCobertura.fechaIngreso",
      key: "fechaIngreso",
      width: "12%",
      render: (_, record) => {
        const fechaIngreso = record?.estatusCobertura?.fechaIngreso;
        return fechaIngreso ? moment(fechaIngreso).format("DD/MM/YYYY") : "N/A";
      },
    },
    {
      title: "Fecha de egreso",
      dataIndex: "estatusCobertura.fechaEgreso",
      key: "fechaEgreso",
      width: "12%",
      render: (_, record) => {
        const fechaEgreso = record?.estatusCobertura?.fechaEgreso;
        return fechaEgreso ? moment(fechaEgreso).format("DD/MM/YYYY") : "N/A";
      },
    },
    {
      title: "Estatus",
      dataIndex: "cobertura.estatus",
      key: "estatus",
      width: "10%",
      align: "center",
      render: (_, record) => {
        const estatus = record?.cobertura?.estatus;

        if (!estatus) {
          return <StatusPill type="info" label="N/A" />;
        }

        const estatusLower = estatus.toLowerCase();

        if (estatusLower.includes("pendiente")) {
          return <StatusPill type="warning" label={estatus} />;
        }

        if (estatusLower.includes("en proceso")) {
          return <StatusPill type="info" label={estatus} />;
        }

        if (
          estatusLower.includes("aprobado") ||
          estatusLower.includes("aceptado") ||
          estatusLower.includes("completado")
        ) {
          return <StatusPill type="success" label={estatus} />;
        }

        if (
          estatusLower.includes("rechazado") ||
          estatusLower.includes("denegado") ||
          estatusLower.includes("cancelado")
        ) {
          return <StatusPill type="error" label={estatus} />;
        }

        return <StatusPill type="info" label={estatus} />;
      },
    },
    {
      title: "Acciones",
      key: "acciones",
      width: "19%",
      align: "center",
      render: (_, record) => renderActionColumn(record),
    },
  ];
};

export const columnasAnexos = ({ abrirModalDocumento }) => {
  return [
    {
      title: "Descripción del archivo",
      dataIndex: "descripcionArchivo",
      key: "descripcionArchivo",
      width: "80%",
      render: (text) => (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
          title={text}
        >
          {text || "N/A"}
        </div>
      ),
    },
    {
      title: "Acciones",
      key: "acciones",
      width: "20%",
      align: "center",
      render: (_, record) => {
        const buttonStylesBase = {
          background: "none",
          border: "none",
          fontSize: "16px",
          padding: "4px 8px",
        };

        const buttonStylesVer = {
          ...buttonStylesBase,
          cursor: "pointer",
          color: "#1890ff",
          opacity: 1,
        };

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              onClick={() => abrirModalDocumento(record)}
              style={buttonStylesVer}
              title="Ver documento"
            >
              <EyeOutlined />
            </button>
          </div>
        );
      },
    },
  ];
};

export const renderActionColumn = ({
  record,
  visibleActionsMenu,
  setVisibleActionsMenu,
  empresa,
  actionsOptions,
  handleMenuClick,
  generarRecordKey,
}) => {
  const recordKey = generarRecordKey(record);
  const isVisible = visibleActionsMenu === recordKey;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Space size={10}>
        <div
          style={{ position: "relative", zIndex: isVisible ? 10000 : "auto" }}
        >
          <Tooltip text="Abrir menú">
            <MenuOutlined
              style={{
                color: empresa?.COLOR_PRINCIPAL,
                fontSize: 25,
                cursor: "pointer",
              }}
              onClick={() => {
                setVisibleActionsMenu(isVisible ? null : recordKey);
              }}
              data-testid="menu-outlined-icon"
            />
          </Tooltip>

          {isVisible && (
            <CustomActionMenu
              handleMenuClick={(action) => handleMenuClick(action, record)}
              options={actionsOptions}
              empresa={empresa}
              record={record}
              colors={Colors}
              testid="custom-action-menu"
            />
          )}
        </div>
      </Space>
    </div>
  );
};

export const prepararDataAnexos = (anexosAMostrar) => {
  return anexosAMostrar.map((anexo, index) => ({
    key: `anexo-${index}`,
    descripcionArchivo: anexo.descripcionArchivo || "N/A",
    rutaArchivo: anexo.rutaArchivo || "N/A",
    ...anexo,
  }));
};
